/**
 * Fold a Polish label for a diacritic-blind, case-blind comparison.
 *
 * The rule that makes this worth a module rather than a one-liner: **`ł` has no Unicode
 * decomposition**, so `NFD` plus `\p{Diacritic}` leaves it standing and a trainer typing „lydki"
 * reaches nothing. It is mapped by hand, in both cases, which is the one thing a naive fold gets
 * wrong and gets wrong silently.
 *
 * ── What this is NOT ────────────────────────────────────────────────────────────────────────
 * `entities/exercise-library`'s `exerciseCatalogue` folds a movement's NAME, and that one also
 * collapses runs of whitespace — a search across a two-word name has to survive a double space the
 * catalogue was authored with. This one folds a short LABEL (a piece of equipment, a muscle group),
 * where there is no run of whitespace to collapse and trimming the ends is the whole of it. Two
 * questions, so two functions; they are not a duplicate pair.
 *
 * Promoted to `shared/lib` on its second consumer — `entities/exercise-library`'s filter tabs and
 * `features/create-exercise`'s equipment search — per `CLAUDE.md`'s promote-on-the-second rule.
 */
export function foldPolish(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/ł/g, 'l')
    .replace(/Ł/g, 'L')
    .toLowerCase()
    .trim();
}
